{
	"asset": {
		"generator": "Khronos glTF Blender I/O v4.1.62",
		"version": "2.0"
	},
	"scene": 0,
	"scenes": [
		{
			"name": "Scene",
			"nodes": [0, 1, 2, 3, 4, 5, 6, 7]
		}
	],
	"nodes": [
		{
			"mesh": 0,
			"name": "Cube.001",
			"rotation": [0, -0.12522557377815247, 0, 0.992128312587738],
			"scale": [0.3457321226596832, 0.34095335006713867, 0.3457321226596832],
			"translation": [-0.8378993272781372, 1.889420986175537, -1.3951458930969238]
		},
		{
			"mesh": 1,
			"name": "Cube.002",
			"rotation": [0, -0.12522558867931366, 0, 0.992128312587738],
			"scale": [0.14516504108905792, 0.14315855503082275, 0.14516504108905792],
			"translation": [-0.8378993272781372, 2.303352117538452, -1.3951458930969238]
		},
		{
			"mesh": 2,
			"name": "Torus",
			"rotation": [0, -0.12522558867931366, 0, 0.992128312587738],
			"scale": [0.19089199602603912, 0.2494911104440689, 0.19089199602603912],
			"translation": [-0.8378993272781372, 2.4240520000457764, -1.3951458930969238]
		},
		{
			"mesh": 3,
			"name": "Cube",
			"scale": [1.280711054801941, 1.2103705406188965, 1.9273290634155273],
			"translation": [0, 2.058312177658081, 0]
		},
		{
			"mesh": 4,
			"name": "Torus.001",
			"rotation": [-0.1014251783490181, 0.1112939715385437, -0.6658972501754761, 0.7306897044181824],
			"scale": [0.0995529517531395, 0.13011319935321808, 0.0995529443025589],
			"translation": [0.15007621049880981, 1.7166236639022827, -1.6607739925384521]
		},
		{
			"mesh": 5,
			"name": "Cube.003",
			"rotation": [-0.1014251708984375, 0.1112939715385437, -0.6658972501754761, 0.7306897044181824],
			"scale": [0.07570568472146988, 0.07465926557779312, 0.07570567727088928],
			"translation": [0.09024205058813095, 1.710795521736145, -1.6421139240264893]
		},
		{
			"mesh": 6,
			"name": "Cube.004",
			"rotation": [-0.1014251783490181, 0.1112939715385437, -0.6658972501754761, 0.7306897640228271],
			"scale": [0.18030430376529694, 0.1778121143579483, 0.18030430376529694],
			"translation": [-0.11495482176542282, 1.690808653831482, -1.5781208276748657]
		},
		{
			"mesh": 7,
			"name": "Plane",
			"scale": [0.2166517972946167, 0.2166517972946167, 0.2166517972946167],
			"translation": [0.18767663836479187, 1.556065559387207, -1.7395789623260498]
		}
	],
	"materials": [
		{
			"doubleSided": true,
			"name": "Material.001",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.6109381318092346, 0, 0.6475950479507446, 1],
				"metallicFactor": 0.7244089841842651,
				"roughnessFactor": 0.24409452080726624
			}
		},
		{
			"doubleSided": true,
			"name": "Material.003",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.10644298791885376, 0, 0.11236762255430222, 1],
				"metallicFactor": 0.7244089841842651,
				"roughnessFactor": 0.24409452080726624
			}
		},
		{
			"doubleSided": true,
			"name": "Material",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.08245865255594254, 0.022615011781454086, 0.023485589772462845, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.5
			}
		},
		{
			"doubleSided": true,
			"name": "Material.006",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.36264768242836, 0.029061559587717056, 0.023437000811100006, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.7086614370346069
			}
		},
		{
			"doubleSided": true,
			"name": "Material.008",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.09671340882778168, 0.0348861962556839, 0.16516107320785522, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.19685038924217224
			}
		}
	],
	"meshes": [
		{
			"name": "Cube.001",
			"primitives": [
				{
					"attributes": {
						"POSITION": 0,
						"NORMAL": 1,
						"TEXCOORD_0": 2
					},
					"indices": 3,
					"material": 0
				}
			]
		},
		{
			"name": "Cube.002",
			"primitives": [
				{
					"attributes": {
						"POSITION": 4,
						"NORMAL": 5,
						"TEXCOORD_0": 6
					},
					"indices": 7,
					"material": 0
				},
				{
					"attributes": {
						"POSITION": 8,
						"NORMAL": 9,
						"TEXCOORD_0": 10
					},
					"indices": 11,
					"material": 1
				}
			]
		},
		{
			"name": "Torus",
			"primitives": [
				{
					"attributes": {
						"POSITION": 12,
						"NORMAL": 13,
						"TEXCOORD_0": 14
					},
					"indices": 15,
					"material": 0
				},
				{
					"attributes": {
						"POSITION": 16,
						"NORMAL": 17,
						"TEXCOORD_0": 18
					},
					"indices": 19,
					"material": 0
				}
			]
		},
		{
			"name": "Cube",
			"primitives": [
				{
					"attributes": {
						"POSITION": 20,
						"NORMAL": 21,
						"TEXCOORD_0": 22
					},
					"indices": 23,
					"material": 2
				},
				{
					"attributes": {
						"POSITION": 24,
						"NORMAL": 25,
						"TEXCOORD_0": 26
					},
					"indices": 27,
					"material": 3
				}
			]
		},
		{
			"name": "Torus.001",
			"primitives": [
				{
					"attributes": {
						"POSITION": 28,
						"NORMAL": 29,
						"TEXCOORD_0": 30
					},
					"indices": 15,
					"material": 0
				},
				{
					"attributes": {
						"POSITION": 31,
						"NORMAL": 32,
						"TEXCOORD_0": 33
					},
					"indices": 19,
					"material": 0
				}
			]
		},
		{
			"name": "Cube.003",
			"primitives": [
				{
					"attributes": {
						"POSITION": 34,
						"NORMAL": 35,
						"TEXCOORD_0": 36
					},
					"indices": 7,
					"material": 0
				},
				{
					"attributes": {
						"POSITION": 37,
						"NORMAL": 38,
						"TEXCOORD_0": 39
					},
					"indices": 11,
					"material": 1
				}
			]
		},
		{
			"name": "Cube.004",
			"primitives": [
				{
					"attributes": {
						"POSITION": 40,
						"NORMAL": 41,
						"TEXCOORD_0": 42
					},
					"indices": 3,
					"material": 0
				}
			]
		},
		{
			"name": "Plane",
			"primitives": [
				{
					"attributes": {
						"POSITION": 43,
						"NORMAL": 44,
						"TEXCOORD_0": 45
					},
					"indices": 46,
					"material": 4
				}
			]
		}
	],
	"accessors": [
		{
			"bufferView": 0,
			"componentType": 5126,
			"count": 24,
			"max": [0.8819447755813599, 0.8659451603889465, 0.8819447755813599],
			"min": [-0.8819447755813599, -1, -0.8819447755813599],
			"type": "VEC3"
		},
		{
			"bufferView": 1,
			"componentType": 5126,
			"count": 24,
			"type": "VEC3"
		},
		{
			"bufferView": 2,
			"componentType": 5126,
			"count": 24,
			"type": "VEC2"
		},
		{
			"bufferView": 3,
			"componentType": 5123,
			"count": 36,
			"type": "SCALAR"
		},
		{
			"bufferView": 4,
			"componentType": 5126,
			"count": 40,
			"max": [1.050765037536621, 1, 1.050765037536621],
			"min": [-1.050765037536621, -1, -1.050765037536621],
			"type": "VEC3"
		},
		{
			"bufferView": 5,
			"componentType": 5126,
			"count": 40,
			"type": "VEC3"
		},
		{
			"bufferView": 6,
			"componentType": 5126,
			"count": 40,
			"type": "VEC2"
		},
		{
			"bufferView": 7,
			"componentType": 5123,
			"count": 66,
			"type": "SCALAR"
		},
		{
			"bufferView": 8,
			"componentType": 5126,
			"count": 8,
			"max": [1.050765037536621, 1, 1.050765037536621],
			"min": [-1.050765037536621, 1, -1.050765037536621],
			"type": "VEC3"
		},
		{
			"bufferView": 9,
			"componentType": 5126,
			"count": 8,
			"type": "VEC3"
		},
		{
			"bufferView": 10,
			"componentType": 5126,
			"count": 8,
			"type": "VEC2"
		},
		{
			"bufferView": 11,
			"componentType": 5123,
			"count": 18,
			"type": "SCALAR"
		},
		{
			"bufferView": 12,
			"componentType": 5126,
			"count": 2112,
			"max": [1.25, 0.25, 1.25],
			"min": [-1.25, -0.25, -1.25],
			"type": "VEC3"
		},
		{
			"bufferView": 13,
			"componentType": 5126,
			"count": 2112,
			"type": "VEC3"
		},
		{
			"bufferView": 14,
			"componentType": 5126,
			"count": 2112,
			"type": "VEC2"
		},
		{
			"bufferView": 15,
			"componentType": 5123,
			"count": 3168,
			"type": "SCALAR"
		},
		{
			"bufferView": 16,
			"componentType": 5126,
			"count": 192,
			"max": [0.8083944320678711, 0.21650634706020355, 0.8451851606369019],
			"min": [-0.875, 3.0616171314629196e-17, -0.8675142526626587],
			"type": "VEC3"
		},
		{
			"bufferView": 17,
			"componentType": 5126,
			"count": 192,
			"type": "VEC3"
		},
		{
			"bufferView": 18,
			"componentType": 5126,
			"count": 192,
			"type": "VEC2"
		},
		{
			"bufferView": 19,
			"componentType": 5123,
			"count": 288,
			"type": "SCALAR"
		},
		{
			"bufferView": 20,
			"componentType": 5126,
			"count": 145,
			"max": [1, -0.4159509241580963, 1.0986552238464355],
			"min": [-1, -2.0708281993865967, -1.114654302597046],
			"type": "VEC3"
		},
		{
			"bufferView": 21,
			"componentType": 5126,
			"count": 145,
			"type": "VEC3"
		},
		{
			"bufferView": 22,
			"componentType": 5126,
			"count": 145,
			"type": "VEC2"
		},
		{
			"bufferView": 23,
			"componentType": 5123,
			"count": 312,
			"type": "SCALAR"
		},
		{
			"bufferView": 24,
			"componentType": 5126,
			"count": 123,
			"max": [1.035993218421936, -0.3914656639099121, 0.5],
			"min": [-1.027809977531433, -1.704187035560608, -0.5],
			"type": "VEC3"
		},
		{
			"bufferView": 25,
			"componentType": 5126,
			"count": 123,
			"type": "VEC3"
		},
		{
			"bufferView": 26,
			"componentType": 5126,
			"count": 123,
			"type": "VEC2"
		},
		{
			"bufferView": 27,
			"componentType": 5123,
			"count": 312,
			"type": "SCALAR"
		},
		{
			"bufferView": 28,
			"componentType": 5126,
			"count": 2112,
			"max": [1.25, 0.25, 1.25],
			"min": [-1.25, -0.25, -1.25],
			"type": "VEC3"
		},
		{
			"bufferView": 29,
			"componentType": 5126,
			"count": 2112,
			"type": "VEC3"
		},
		{
			"bufferView": 30,
			"componentType": 5126,
			"count": 2112,
			"type": "VEC2"
		},
		{
			"bufferView": 31,
			"componentType": 5126,
			"count": 192,
			"max": [0.8083944320678711, 0.21650634706020355, 0.8451851606369019],
			"min": [-0.875, 3.0616171314629196e-17, -0.8675142526626587],
			"type": "VEC3"
		},
		{
			"bufferView": 32,
			"componentType": 5126,
			"count": 192,
			"type": "VEC3"
		},
		{
			"bufferView": 33,
			"componentType": 5126,
			"count": 192,
			"type": "VEC2"
		},
		{
			"bufferView": 34,
			"componentType": 5126,
			"count": 40,
			"max": [1.050765037536621, 1, 1.050765037536621],
			"min": [-1.050765037536621, -1, -1.050765037536621],
			"type": "VEC3"
		},
		{
			"bufferView": 35,
			"componentType": 5126,
			"count": 40,
			"type": "VEC3"
		},
		{
			"bufferView": 36,
			"componentType": 5126,
			"count": 40,
			"type": "VEC2"
		},
		{
			"bufferView": 37,
			"componentType": 5126,
			"count": 8,
			"max": [1.050765037536621, 1, 1.050765037536621],
			"min": [-1.050765037536621, 1, -1.050765037536621],
			"type": "VEC3"
		},
		{
			"bufferView": 38,
			"componentType": 5126,
			"count": 8,
			"type": "VEC3"
		},
		{
			"bufferView": 39,
			"componentType": 5126,
			"count": 8,
			"type": "VEC2"
		},
		{
			"bufferView": 40,
			"componentType": 5126,
			"count": 24,
			"max": [0.8819447755813599, 0.8659451603889465, 0.8819447755813599],
			"min": [-0.8819447755813599, -1, -0.8819447755813599],
			"type": "VEC3"
		},
		{
			"bufferView": 41,
			"componentType": 5126,
			"count": 24,
			"type": "VEC3"
		},
		{
			"bufferView": 42,
			"componentType": 5126,
			"count": 24,
			"type": "VEC2"
		},
		{
			"bufferView": 43,
			"componentType": 5126,
			"count": 34,
			"max": [1.3241127729415894, 3.267016950303514e-7, 1],
			"min": [-1.1087802648544312, -1.9344180657299148e-7, -1.006471872329712],
			"type": "VEC3"
		},
		{
			"bufferView": 44,
			"componentType": 5126,
			"count": 34,
			"type": "VEC3"
		},
		{
			"bufferView": 45,
			"componentType": 5126,
			"count": 34,
			"type": "VEC2"
		},
		{
			"bufferView": 46,
			"componentType": 5123,
			"count": 120,
			"type": "SCALAR"
		}
	],
	"bufferViews": [
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 0,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 288,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 192,
			"byteOffset": 576,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 72,
			"byteOffset": 768,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 480,
			"byteOffset": 840,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 480,
			"byteOffset": 1320,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 320,
			"byteOffset": 1800,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 132,
			"byteOffset": 2120,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 96,
			"byteOffset": 2252,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 96,
			"byteOffset": 2348,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 64,
			"byteOffset": 2444,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 36,
			"byteOffset": 2508,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 25344,
			"byteOffset": 2544,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 25344,
			"byteOffset": 27888,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 16896,
			"byteOffset": 53232,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 6336,
			"byteOffset": 70128,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 2304,
			"byteOffset": 76464,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 2304,
			"byteOffset": 78768,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1536,
			"byteOffset": 81072,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 576,
			"byteOffset": 82608,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 1740,
			"byteOffset": 83184,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1740,
			"byteOffset": 84924,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1160,
			"byteOffset": 86664,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 624,
			"byteOffset": 87824,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 1476,
			"byteOffset": 88448,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1476,
			"byteOffset": 89924,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 984,
			"byteOffset": 91400,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 624,
			"byteOffset": 92384,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 25344,
			"byteOffset": 93008,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 25344,
			"byteOffset": 118352,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 16896,
			"byteOffset": 143696,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 2304,
			"byteOffset": 160592,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 2304,
			"byteOffset": 162896,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1536,
			"byteOffset": 165200,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 480,
			"byteOffset": 166736,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 480,
			"byteOffset": 167216,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 320,
			"byteOffset": 167696,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 96,
			"byteOffset": 168016,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 96,
			"byteOffset": 168112,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 64,
			"byteOffset": 168208,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 168272,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 168560,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 192,
			"byteOffset": 168848,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 408,
			"byteOffset": 169040,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 408,
			"byteOffset": 169448,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 272,
			"byteOffset": 169856,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 240,
			"byteOffset": 170128,
			"target": 34963
		}
	],
	"buffers": [
		{
			"byteLength": 170368,
			"uri": "bottle%20table.bin"
		}
	]
}
